import { t } from 'i18next';
import { useDispatch } from 'react-redux';
import { MainButton } from '../../../components/Buttons/MainButton';
import { setAccountSettingsModals } from '../../../redux/accountSettingsPage/accountSettingsSlice';
import {
  accountSettingsCardFieldStyles,
  fieldRowStyles,
  settingTitleStyles,
} from './styles';

const AccountSettingsBlockedUsersField = () => {
  const dispatch = useDispatch();

  const openBlockedUsersModal = () => {
    dispatch(setAccountSettingsModals({ isBlockedUsersModalOpen: true }));
  };

  return (
    <div style={accountSettingsCardFieldStyles}>
      <div style={fieldRowStyles.row}>
        <div style={{ ...fieldRowStyles.infoContainer, ...settingTitleStyles }}>
          {t('accountSettings.blockedUsers')}
        </div>
        <MainButton
          onPress={openBlockedUsersModal}
          variant="outlined"
          size="small"
          typeStyle="secondary"
          text={t('common.change')}
        />
      </div>
    </div>
  );
};

export default AccountSettingsBlockedUsersField;
